import type { Category } from "./categories";

export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: Category;
  author: string;
  publishDate: string;
  readTime: string;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    slug: "2025-best-design-resources",
    title: "2025年最值得收藏的50个设计资源网站",
    excerpt: "精心整理的2025年设计师必备资源网站合集，涵盖灵感、素材、字体、配色等各个方面，让你的设计效率翻倍。",
    content: `<p>在数字化浪潮席卷全球的今天，设计资源的获取方式正在发生深刻变革。无论是专业设计师还是设计爱好者，掌握优质的设计资源入口都能极大提升创作效率。本文将为您系统梳理2025年最具价值的50个设计资源网站。</p>
    <h2>一、灵感启发类资源</h2>
    <p>设计的第一步往往是从获取灵感开始。优秀的灵感网站能够帮助设计师快速打开思路，找到创作方向。Dribbble和Behance作为全球最大的设计师社区，汇聚了来自世界各地的优秀设计作品，是设计师日常浏览的必备平台。Pinterest则以其强大的图片推荐算法著称，能够根据你的浏览偏好精准推送相关设计内容。此外，Awwwards专注于评选和展示全球最佳网站设计，是网页设计师获取灵感的重要来源。</p>
    <h2>二、素材资源类</h2>
    <p>高质量的设计素材是提升作品品质的关键。Unsplash和Pexels提供海量免费高清图片，涵盖自然风光、城市建筑、人物肖像等各类主题。Freepik和Vecteezy则专注于矢量图形和插画资源，提供大量可商用的设计素材。Iconfont和Flaticon是图标资源的两大巨头，拥有数以万计的风格各异的图标供设计师选用。</p>
    <h2>三、字体资源类</h2>
    <p>字体是设计中不可或缺的元素，合适的字体能够赋予设计作品独特的个性与气质。Google Fonts提供了超过1000款开源免费字体，支持多语言并可直接在网页中引用。字体天下和字体之家则是中文字体资源的重要平台，收录了大量的中文字体供设计师下载使用。</p>
    <h2>四、配色工具类</h2>
    <p>色彩搭配是设计中最具挑战性的环节之一。Coolors和Adobe Color是两款优秀的配色工具，能够帮助设计师快速生成协调的色彩方案。中国色则专注于中国传统色彩的研究与展示，为需要东方美学风格的设计提供了丰富的配色参考。</p>
    <h2>五、效率工具类</h2>
    <p>除了创意和素材，高效的工具体系同样重要。Figma作为云端协作设计工具的领导者，已经成为了众多设计团队的首选。Canva则降低了设计门槛，让非专业用户也能快速制作出精美的视觉内容。Remove.bg的AI抠图功能、TinyPNG的图片压缩功能则解决了许多日常设计中的痛点问题。</p>
    <p>以上50个设计资源网站涵盖了设计师工作流程的各个环节，合理利用这些资源，将大幅提升您的设计效率与作品品质。建议将常用网站添加到浏览器收藏夹，建立自己的设计资源体系。</p>`,
    category: {
      id: 1,
      slug: "resource-navigation",
      name: "资源导航",
      description: "",
      icon: "",
      count: 0,
    },
    author: "设计资源编辑组",
    publishDate: "2025-06-15",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20design%20studio%20workspace%20with%20color%20palettes%20sketchbooks%20and%20a%20large%20monitor%20displaying%20UI%20design%20minimal%20clean%20aesthetic%20warm%20natural%20lighting%20professional%20creative%20environment&width=800&height=450&seq=article-design-01&orientation=landscape",
    tags: ["设计资源", "设计师", "灵感", "素材"],
  },
  {
    id: 2,
    slug: "ai-tools-2025-guide",
    title: "AI工具使用完全指南：从入门到精通",
    excerpt: "全面解析2025年主流AI工具的使用方法与应用场景，帮助零基础用户快速掌握AI工具提升工作效率。",
    content: `<p>人工智能技术正在以前所未有的速度改变着我们的工作和生活方式。从文本生成到图像创作，从代码编写到数据分析，AI工具已经渗透到了各个领域。本文将为您提供一份全面的AI工具使用指南，帮助您从零开始掌握这些强大的工具。</p>
    <h2>一、AI文本生成工具</h2>
    <p>ChatGPT作为文本生成领域的标杆产品，能够协助用户完成文章撰写、代码生成、翻译校对等多种任务。使用ChatGPT的关键在于掌握Prompt提示词的编写技巧——清晰、具体、有上下文的提示词能够获得更精准的回复。国内的文心一言、通义千问等产品也在快速迭代，提供了更适合中文场景的AI文本服务。</p>
    <h2>二、AI图像生成工具</h2>
    <p>Midjourney和Stable Diffusion是目前最受欢迎的两款AI图像生成工具。Midjourney以其出色的艺术风格表现力著称，适合创作概念设计、插画和艺术图像。Stable Diffusion则以其开源灵活的特性吸引了大量开发者和创作者，可以通过各类插件和模型实现高度定制化的图像生成。使用时需要注意提示词的撰写技巧，包括描述主体、风格、构图、光照等要素。</p>
    <h2>三、AI办公效率工具</h2>
    <p>Notion AI将AI能力融入笔记和项目管理中，能够自动总结会议纪要、生成待办事项、优化文档结构。Microsoft Copilot则将AI深度集成到Office套件中，在Word、Excel、PowerPoint中提供智能辅助功能。Gamma和Beautiful.ai利用AI技术帮助用户快速创建精美的演示文稿。</p>
    <h2>四、AI编程辅助工具</h2>
    <p>GitHub Copilot和Cursor已经成为开发者不可或缺的编程助手，能够根据上下文自动补全代码、生成函数、解释复杂逻辑。这些工具不仅提高了编程效率，还降低了编程入门门槛。使用AI编程工具时，建议将AI视为协作伙伴而非替代品，保持对代码的理解和把控。</p>
    <h2>五、AI工具使用的注意事项</h2>
    <p>在使用AI工具时，需要注意以下几点：首先，AI生成的内容可能存在事实性错误，重要信息需要人工核实。其次，涉及隐私和敏感数据的内容应避免输入AI工具。最后，合理使用AI工具提升效率，但不要过度依赖而丧失独立思考能力。</p>`,
    category: {
      id: 2,
      slug: "tools-software",
      name: "工具软件",
      description: "",
      icon: "",
      count: 0,
    },
    author: "技术评测团队",
    publishDate: "2025-06-10",
    readTime: "10分钟",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20glowing%20neural%20network%20connections%20on%20a%20dark%20background%20abstract%20digital%20brain%20visualization%20with%20warm%20golden%20and%20coral%20accent%20lights&width=800&height=450&seq=article-ai-02&orientation=landscape",
    tags: ["AI工具", "人工智能", "效率工具", "ChatGPT"],
  },
  {
    id: 3,
    slug: "web-dev-learning-roadmap",
    title: "Web开发学习路线图：2025年最新版",
    excerpt: "为零基础学员量身定制的Web开发学习路径，从HTML基础到全栈开发，循序渐进掌握核心技能。",
    content: `<p>Web开发作为互联网行业最热门的技能方向之一，吸引了大量学习者的关注。然而面对纷繁复杂的技术栈，很多初学者往往不知从何入手。本文将为不同阶段的学习者提供清晰的学习路线图。</p>
    <h2>一、前端基础阶段（1-2个月）</h2>
    <p>Web开发的第一步是掌握前端三大基石：HTML、CSS和JavaScript。HTML负责网页的结构和内容，CSS负责页面的样式和布局，JavaScript则赋予网页交互能力。建议初学者先从构建静态网页开始，逐步过渡到动态交互页面。推荐学习资源包括MDN Web Docs、freeCodeCamp和W3Schools。</p>
    <h2>二、前端进阶阶段（2-3个月）</h2>
    <p>在掌握基础之后，需要学习现代前端框架。React是目前最受欢迎的框架之一，建议深入学习其核心概念如组件化、状态管理、路由等。同时需要了解打包工具如Vite和Webpack，以及TypeScript为代码添加类型安全。Tailwind CSS作为实用优先的CSS框架，能够大幅提升样式开发效率。</p>
    <h2>三、后端开发入门（2-3个月）</h2>
    <p>前端开发者向全栈发展时，需要选择一门后端语言。Node.js是前端开发者的自然选择，可以复用JavaScript知识。学习重点包括Express或Koa框架、数据库操作（SQL和NoSQL）、API设计、用户认证等。Supabase等BaaS平台可以大幅简化后端开发流程。</p>
    <h2>四、全栈项目实战（1-2个月）</h2>
    <p>理论知识需要通过项目实践来巩固。建议从简单项目开始，如个人博客、待办事项应用，逐步挑战更复杂的项目如电商网站、社交平台等。在实战中学习版本控制（Git）、部署上线、性能优化等实用技能。</p>
    <h2>五、持续学习与职业发展</h2>
    <p>Web技术日新月异，保持学习热情至关重要。关注技术博客、参与开源项目、加入技术社区都是持续成长的有效途径。建议每季度学习一项新技术或深入一个已有技术领域。</p>`,
    category: {
      id: 3,
      slug: "learning-tutorials",
      name: "学习教程",
      description: "",
      icon: "",
      count: 0,
    },
    author: "教程编写组",
    publishDate: "2025-05-28",
    readTime: "12分钟",
    image: "https://readdy.ai/api/search-image?query=Clean%20modern%20coding%20workspace%20with%20laptop%20displaying%20code%20editor%20on%20wooden%20desk%20warm%20ambient%20lighting%20minimal%20setup%20with%20notebook%20and%20coffee&width=800&height=450&seq=article-webdev-03&orientation=landscape",
    tags: ["Web开发", "学习路线", "前端", "全栈"],
  },
  {
    id: 4,
    slug: "china-internet-trends-2025",
    title: "2025年中国互联网行业发展趋势深度分析",
    excerpt: "深度剖析2025年中国互联网行业的最新趋势与变革，从AI应用到数字经济，全面解读行业走向。",
    content: `<p>2025年，中国互联网行业正经历着深刻的变革与重构。在AI技术爆发、监管政策完善、用户需求升级的多重驱动下，行业格局正在发生显著变化。本文将从多个维度分析当前行业趋势。</p>
    <h2>一、AI驱动的产业升级</h2>
    <p>人工智能已从概念验证阶段进入大规模应用落地阶段。各大互联网企业纷纷将AI能力融入核心产品，从搜索、推荐到内容生成，AI正在重塑用户体验。特别是在企业服务领域，AI驱动的SaaS产品正在帮助传统行业实现数字化转型，提升运营效率。</p>
    <h2>二、内容生态的深度变革</h2>
    <p>短视频和直播依然是用户获取信息和娱乐的主要渠道，但内容形式正在变得更加多元。AI生成内容（AIGC）的兴起为内容创作带来了新的可能性，同时也引发了关于内容质量和版权的新讨论。高质量、有深度的原创内容价值进一步凸显。</p>
    <h2>三、电商与本地生活的融合</h2>
    <p>即时零售和社区团购持续增长，线上线下的界限日益模糊。各大平台加速布局本地生活服务，从餐饮外卖延伸到家政、美业、教育等更多品类。内容电商和直播电商已成为品牌营销的标配。</p>
    <h2>四、数字经济的政策环境</h2>
    <p>数据安全法、个人信息保护法等法规的深入实施，推动互联网企业加强合规建设。平台经济健康发展成为政策主基调，反垄断和公平竞争监管持续完善。在规范中发展、在发展中规范成为行业共识。</p>
    <h2>五、出海与全球化布局</h2>
    <p>中国互联网企业的全球化步伐加快，跨境电商、游戏出海、工具出海等赛道持续火热。东南亚、中东、拉美等新兴市场成为中国企业的重要增长极。本地化运营能力和合规意识成为出海成功的关键。</p>`,
    category: {
      id: 4,
      slug: "industry-news",
      name: "行业资讯",
      description: "",
      icon: "",
      count: 0,
    },
    author: "行业研究部",
    publishDate: "2025-06-02",
    readTime: "9分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20skyline%20at%20sunset%20with%20digital%20data%20visualization%20overlay%20warm%20golden%20tones%20representing%20internet%20industry%20growth%20and%20technology%20trends&width=800&height=450&seq=article-trends-04&orientation=landscape",
    tags: ["互联网趋势", "行业分析", "数字经济", "AI"],
  },
  {
    id: 5,
    slug: "vip-member-guide",
    title: "91网VIP会员使用完全指南",
    excerpt: "详细介绍91网VIP会员的各项权益与使用技巧，帮助会员充分享受平台提供的优质服务。",
    content: `<p>91网VIP会员体系自上线以来，已为超过百万会员提供了优质的资源服务。本文将全面介绍VIP会员的各项权益及使用技巧，帮助您充分享受会员服务。</p>
    <h2>一、会员等级体系</h2>
    <p>91网会员分为普通会员、银牌会员、金牌会员和钻石会员四个等级。新注册用户默认为普通会员，可通过充值升级到更高级别。不同等级享有不同的资源下载配额、下载速度和服务优先级。钻石会员还享有专属客服经理和定制化资源推荐服务。</p>
    <h2>二、核心权益详解</h2>
    <p>VIP会员的核心权益包括：无限资源下载、高速下载通道、专属客服支持、每日资源推送、商业使用授权和社区专属活动参与资格。其中高速下载通道能够将下载速度提升至普通用户的5倍以上，大幅节省等待时间。</p>
    <h2>三、会员使用技巧</h2>
    <p>建议会员充分利用平台的收藏和分类功能，建立自己的资源管理体系。开启每日推送后，可以根据个人偏好调整推送内容类型。定期查看会员专属页面，了解最新的会员活动和福利信息。参与社区讨论和资源评价还可以获得额外的积分奖励。</p>
    <h2>四、常见问题解答</h2>
    <p>会员到期后资源是否会失效？已下载到本地的资源不会失效，但无法继续下载新资源。可以随时续费恢复会员资格。会员能否退款？首次开通7天内未使用任何下载额度可申请退款。不同设备能否同时登录？同一账号支持同时在3台设备上登录使用。</p>`,
    category: {
      id: 5,
      slug: "member-services",
      name: "会员服务",
      description: "",
      icon: "",
      count: 0,
    },
    author: "会员服务中心",
    publishDate: "2025-06-08",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=Premium%20membership%20concept%20with%20elegant%20golden%20card%20on%20a%20warm%20minimal%20background%20luxurious%20feel%20with%20soft%20lighting%20and%20refined%20aesthetic&width=800&height=450&seq=article-vip-05&orientation=landscape",
    tags: ["会员指南", "VIP", "使用技巧", "91网"],
  },
  {
    id: 6,
    slug: "productivity-tools-collection",
    title: "提升工作效率的30款神器级工具推荐",
    excerpt: "精挑细选30款能够显著提升工作效率的实用工具，从时间管理到自动化处理，全面优化工作流程。",
    content: `<p>在信息爆炸的时代，高效的工具是提升生产力的关键。本文为您精选了30款经过实际验证的高效工具，覆盖工作流中的各个环节。</p>
    <h2>一、时间管理工具</h2>
    <p>Toggl Track是一款简洁的时间追踪工具，帮助您了解时间分配情况。Forest通过种树的游戏化方式帮助保持专注。Todoist是目前功能最全面的待办事项管理工具之一。</p>
    <h2>二、文档协作工具</h2>
    <p>Notion集笔记、知识库、项目管理于一体，是团队协作的瑞士军刀。飞书文档提供了流畅的中文协作体验。Obsidian以其双向链接和知识图谱功能，成为个人知识管理的首选。</p>
    <h2>三、文件管理工具</h2>
    <p>Dropbox和Google Drive提供稳定的云存储服务。Everything是一款Windows上的文件搜索神器，能够瞬间定位任意文件。7-Zip是开源免费的压缩解压工具，支持多种格式。</p>
    <h2>四、自动化工具</h2>
    <p>Zapier和Make（原Integromat）能够连接不同应用实现工作流自动化。AutoHotkey是Windows平台上的自动化脚本工具，可以自定义键盘快捷键。Raycast在Mac平台上提供了强大的快速启动和自动化能力。</p>
    <p>合理运用这些工具，每天可以节省1-2小时的工作时间。建议根据自己的实际需求选择3-5款工具深度使用，而非浅尝辄止地尝试所有工具。</p>`,
    category: {
      id: 2,
      slug: "tools-software",
      name: "工具软件",
      description: "",
      icon: "",
      count: 0,
    },
    author: "效率工具评测组",
    publishDate: "2025-05-20",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20setup%20with%20productivity%20tools%20notebooks%20and%20minimal%20workspace%20warm%20natural%20lighting%20professional%20environment&width=800&height=450&seq=article-tools-06&orientation=landscape",
    tags: ["效率工具", "生产力", "工作流", "工具推荐"],
  },
  {
    id: 7,
    slug: "freelancer-survival-guide",
    title: "自由职业者生存指南：从0到1建立个人品牌",
    excerpt: "面向自由职业者的全方位实战指南，涵盖接单渠道、定价策略、客户沟通和品牌建设等关键环节。",
    content: `<p>自由职业正成为越来越多人的职业选择。然而，从职场转型为自由职业者，需要的不仅是专业技能，更需要全面的自我经营能力。本文将从多个维度为您提供实战指导。</p>
    <h2>一、选择你的赛道</h2>
    <p>自由职业的第一步是明确自己的核心技能和服务方向。目前需求较大的自由职业领域包括：程序设计、UI/UX设计、内容创作、翻译、数字营销、视频制作等。建议选择自己最擅长且有市场需求的方向深耕，避免同时涉足过多领域导致精力分散。</p>
    <h2>二、建立接单渠道</h2>
    <p>自由职业者的主要接单渠道包括：专业自由职业平台（如Upwork、Freelancer、猪八戒网）、社交媒体获客（LinkedIn、知乎、小红书）、个人网站和作品集展示、以及行业人脉推荐。建议初期多平台布局，逐步筛选出最适合自己的获客渠道。</p>
    <h2>三、定价与合同管理</h2>
    <p>合理的定价是自由职业可持续发展的基础。建议参考行业平均水平，综合考虑自身经验、项目难度和时间投入来定价。务必在项目开始前签订合同，明确交付内容、时间节点、付款方式和修改次数等关键条款。</p>
    <h2>四、时间与财务管理</h2>
    <p>自由职业者需要自己管理时间和财务。建议建立固定的工作节奏，使用时间管理工具追踪项目进度。在财务方面，需要合理规划收入、缴纳税款、购买社保，并建立应急储备金。</p>
    <h2>五、持续学习与个人品牌</h2>
    <p>自由职业者的竞争力在于持续学习。定期更新技能，关注行业动态。同时，通过社交媒体、技术博客等方式建立个人品牌，能够吸引更优质的客户并提升议价能力。</p>`,
    category: {
      id: 3,
      slug: "learning-tutorials",
      name: "学习教程",
      description: "",
      icon: "",
      count: 0,
    },
    author: "职业发展专栏",
    publishDate: "2025-05-15",
    readTime: "11分钟",
    image: "https://readdy.ai/api/search-image?query=Freelancer%20working%20remotely%20in%20a%20cozy%20modern%20cafe%20with%20laptop%20and%20notebook%20warm%20atmospheric%20lighting%20creative%20workspace%20vibe&width=800&height=450&seq=article-freelance-07&orientation=landscape",
    tags: ["自由职业", "个人品牌", "职业规划", "接单"],
  },
  {
    id: 8,
    slug: "china-ai-policy-2025",
    title: "2025年中国人工智能政策全景解读",
    excerpt: "系统梳理2025年中国在人工智能领域的政策法规，帮助从业者把握政策方向与合规要点。",
    content: `<p>随着人工智能技术的快速发展，中国在AI领域的政策法规体系也在不断完善。2025年，多项重要政策出台或更新，对整个行业产生了深远影响。本文将为读者全面解读当前的AI政策环境。</p>
    <h2>一、AI治理框架</h2>
    <p>中国已初步建立起以《生成式人工智能服务管理暂行办法》为核心的AI治理框架。该框架强调发展与安全并重，在鼓励技术创新的同时，要求AI服务提供者履行内容安全、数据安全和个人信息保护等责任。</p>
    <h2>二、数据安全与隐私保护</h2>
    <p>《数据安全法》和《个人信息保护法》构成了AI领域数据治理的法律基础。AI企业在收集、处理和使用数据时，需要严格遵守相关法规，建立完善的数据分类分级管理制度和用户知情同意机制。</p>
    <h2>三、行业应用规范</h2>
    <p>在金融、医疗、教育等垂直领域，监管部门陆续出台了AI应用的专项规范。例如，金融领域要求AI决策过程可解释、可追溯；医疗领域要求AI辅助诊断系统需要通过严格的审批流程。</p>
    <h2>四、知识产权保护</h2>
    <p>AI生成内容的知识产权归属问题持续受到关注。目前的司法实践中，对于AI参与创作的作品，一般需要有人类创作者的实质性贡献才能获得著作权保护。企业在使用AI生成内容时需注意合规风险。</p>
    <h2>五、未来展望</h2>
    <p>预计未来中国AI政策将继续沿着"促进创新、保障安全、维护权益"的方向演进。建议AI从业者密切关注政策动态，建立合规管理体系，在合法合规的前提下充分释放AI技术价值。</p>`,
    category: {
      id: 4,
      slug: "industry-news",
      name: "行业资讯",
      description: "",
      icon: "",
      count: 0,
    },
    author: "政策研究组",
    publishDate: "2025-05-22",
    readTime: "9分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20government%20building%20with%20digital%20technology%20elements%20clean%20professional%20atmosphere%20warm%20lighting%20representing%20policy%20and%20innovation&width=800&height=450&seq=article-policy-08&orientation=landscape",
    tags: ["AI政策", "法规解读", "合规", "数据安全"],
  },
  {
    id: 9,
    slug: "remote-work-best-practices",
    title: "远程办公最佳实践：高效协作的10个黄金法则",
    excerpt: "总结远程办公中的高效协作方法，从沟通机制到工具选择，帮助团队实现无缝远程协作。",
    content: `<p>远程办公已经从特殊时期的应急措施演变为许多企业的常态化工作模式。然而，远程办公对团队的沟通协作能力提出了更高要求。本文总结了10个经过验证的高效远程协作法则。</p>
    <h2>法则一：建立清晰的沟通协议</h2>
    <p>远程团队需要制定明确的沟通规范，包括：什么情况下使用同步沟通（视频会议、即时消息），什么情况下使用异步沟通（邮件、协作文档）。建议为不同类型的沟通设定响应时间预期，避免团队成员产生焦虑。</p>
    <h2>法则二：选择合适的协作工具</h2>
    <p>优秀的协作工具体系是远程办公的基础设施。视频会议可以选择Zoom或腾讯会议，即时沟通使用Slack或飞书，项目管理使用Linear、Jira或飞书多维表格。关键不在于工具数量，而在于团队统一使用并形成习惯。</p>
    <h2>法则三：定期同步与复盘</h2>
    <p>建议团队保持每日站会（15分钟以内）、每周周会和每月月度复盘。站会聚焦于当日计划和阻塞点，周会回顾进度和调整计划，月度复盘则从更高层面审视目标和方向。</p>
    <h2>法则四：文档驱动的工作文化</h2>
    <p>远程团队应建立"文档优先"的文化，将决策过程、会议纪要、项目进展等信息沉淀为可检索的文档。这不仅有助于信息透明，也能减少不必要的会议和重复沟通。</p>
    <h2>法则五：关注团队心理健康</h2>
    <p>远程办公可能导致社交隔离感和工作与生活界限模糊。管理者需要定期与团队成员进行一对一沟通，关注其心理状态。团队也可以组织线上团建活动，增强团队凝聚力。</p>`,
    category: {
      id: 3,
      slug: "learning-tutorials",
      name: "学习教程",
      description: "",
      icon: "",
      count: 0,
    },
    author: "管理实践专栏",
    publishDate: "2025-05-18",
    readTime: "9分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20home%20office%20setup%20with%20clean%20minimal%20design%20laptop%20on%20wooden%20desk%20natural%20light%20plants%20warm%20cozy%20atmosphere&width=800&height=450&seq=article-remote-09&orientation=landscape",
    tags: ["远程办公", "团队协作", "效率", "管理"],
  },
];